import React from 'react'
import classes from './CheckData.module.css'

const CheckData = (props) => {

    const { condition, name, value, data, codeName, out, secondValue, link } = props

    return (
        <>
            {!data ?
                <div className={classes.post__wrapper} style={{ display: condition ? 'flex' : 'none' }}>
                    <div className={classes.wrapper}>
                        <div className={classes.post}>
                            {name}
                        </div>
                        <div className={classes.rate}>
                            <div className={classes.post__value}>
                                {link ?
                                    secondValue ?
                                        <div style={{ flexDirection: 'column' }}>
                                            <div>{value}</div>
                                            <div style={{ marginTop: 5 }}>{secondValue}</div>
                                        </div>
                                        : <a href={link} target="_blank" rel={'noopener noreferrer'}>
                                            {value ? value.slice(0, 5) + '...' + value.slice(-5) : null}
                                        </a>
                                    :
                                    secondValue ?
                                        <div style={{ flexDirection: 'column' }}>
                                            <div>{value}</div>
                                            <div style={{ marginTop: 5 }}>{secondValue}</div>
                                        </div>
                                        : value}
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div className={classes.data__wrapper}>
                    <div className={classes.data__name}>
                        <div className={classes.data}>
                            {name}
                        </div>
                        <div className={classes.data}>
                            {codeName}
                        </div>
                    </div>
                    <div className={classes.data__value} style={{ color: out ? '#7127AC' : '#404040' }} >
                        {secondValue ?
                            <div style={{ flexDirection: 'column' }}>
                                <div>{value}</div>
                                <div style={{ marginTop: 5 }}>{secondValue}</div>
                            </div>
                            : value}
                    </div>
                </div>}
        </>
    )
}

export default CheckData